import { render, staticRenderFns } from "./PreviewFormsNCD.vue?vue&type=template&id=3c6f953d"
import script from "./PreviewFormsNCD.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsNCD.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports